module.exports = __webpack_public_path__ + "assets/images/diseases_g.7eacf820.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/diseases_g.png
// module id = 701
// module chunks = 1